import * as firebase from "firebase/app";
import "firebase/auth";
import "firebase/analytics";
import { Config, firebaseConfig, firebaseConfig_test } from '../Config';
import { isBrowser, isAndroid} from 'react-device-detect';

export default class FirebaseLogger {

    static myInstance = null;
    _initiated = null;

    /**
     * @returns {FirebaseLogger}
     */
    static getInstance() {
			if (FirebaseLogger.myInstance == null) {
				FirebaseLogger.myInstance = new FirebaseLogger();
				this.myInstance._init();
			}
			return this.myInstance;
    }
    
    async _init() {
			if (this._initiated) return false;
			try {
				//console.log("FirebaseLogger", "init");
				this._initiated = true;
				firebase.initializeApp(Config.test == "0" ? firebaseConfig : firebaseConfig_test);
				return true;
			} catch (error) {
				//console.warn("firebase.initializeApp", error);
				return false
			}
    }
    regEvent(eventName, params, action) {
			let eventPrefix = Config.test == 1 ? "TEST_WEB_" : "WEB_";
			if (action) eventPrefix += action + "_";
			//console.log('[FirebaseLogger] @checkForGoogleEventLogger #eventName', eventName);
			params.os = isBrowser ? "web" : isAndroid ? "android" : "ios";
			//console.log('[FirebaseLogger] @checkForGoogleEventLogger #params', params);
			//console.log('[FirebaseLogger] @checkForGoogleEventLogger #all', eventPrefix + eventName, params);
        
			firebase.analytics().logEvent(
				eventPrefix + eventName,
				params
			);
			return
    }
}



// WEBPACK FOOTER //
// ./src/libs/FirebaseLogger.js